var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLocationIcon = function SvgLocationIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 12,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#242E30",
    d: "M8.908 1.319a5.018 5.018 0 0 0-7.09 7.089L5.364 12l3.545-3.545a5.02 5.02 0 0 0 0-7.136M8.073 7.62l-2.71 2.67-2.71-2.71a3.844 3.844 0 0 1 0-5.426 3.844 3.844 0 0 1 5.42 0 3.844 3.844 0 0 1 0 5.427zm-2.71-4.876a2.166 2.166 0 1 0 0 4.333 2.166 2.166 0 0 0 0-4.333m0 3.151a.985.985 0 1 1 0-1.97.985.985 0 0 1 0 1.97"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLocationIcon);
export default ForwardRef;